var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "extension",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M31.714,17.143H29.143V10.286a3.428,3.428,0,0,0-3.429-3.429H18.857V4.286a4.286,4.286,0,0,0-8.571,0V6.857H3.429A3.413,3.413,0,0,0,.017,10.286L.009,16.8H2.571a4.629,4.629,0,1,1,0,9.257H.009L0,32.571A3.428,3.428,0,0,0,3.429,36H9.943V33.429a4.629,4.629,0,1,1,9.257,0V36h6.514a3.428,3.428,0,0,0,3.429-3.429V25.714h2.571a4.286,4.286,0,0,0,0-8.571Z",
    fill: "#4397d2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtension);
export default __webpack_public_path__ + "static/media/extension.d33260fc8efae250d87fdbc5f1ce5203.svg";
export { ForwardRef as ReactComponent };